import { RESET } from 'jotai/utils'

import { resetContentDesignForm } from '@/content-from-sections/client'
import { getStore } from '@/store'

import { contentFormValidityAtom } from '../generatorState'
import { resetAboutForm } from './AboutForm'
import { resetAppForm } from './AppForm'
import { resetBusinessInfoForm } from './BusinessInfoForm'
import { resetImagesField } from './CommonSections/ImagesField'
import { resetContactInfoForm } from './ContactInfoForm/ContactInfoForm'
import { resetFacebookForm } from './FacebookForm'
import { resetFacilitiesForm } from './FacilitiesForm/FacilitiesForm'
import { resetImageField } from './ImageForm'
import { resetImagesInfoForm } from './ImagesInfoForm'
import { resetAddressForm } from './LocationForm/addressAtoms'
import { resetMenuForm } from './MenuForm/MenuForm'
import { resetRestaurantInfoForm } from './MenuForm/RestaurantInfo'
import { resetOpeningHoursForm } from './OpeningHoursForm/openingHoursState'
import { resetPdf } from './PdfForm/PdfUpload'
import { resetPlainTextForm } from './PlainTextForm'
import { resetQrNameForm } from './QrNameForm'
import { resetShareImageGalleryForm } from './ShareImagesForm'
import { resetSocialInformationForm } from './SocialInformationForm'
import { resetCustomSocialImagesField } from './SocialLinksForm/CustomSocialImageUpload'
import { resetSocialLinksForm } from './SocialLinksForm/SocialLinksForm'
import { resetSummaryAtom } from './SummaryForm/SummarySection'
import { resetVideoForm, resetVideoList } from './VideoForm/VideoForm'
import { resetVideoInformationForm } from './VideoForm/VideoInformationForm'
import { resetWebsiteUrlForm } from './WebsiteUrlForm'
import { resetWelcomeScreenForm } from './WelcomeScreenForm'
import { resetWifiForm } from './WifiForm'

// Reset only the section-validity bookkeeping, without touching content
// values. Needed when re-entering the same QR type (content is intentionally
// preserved) so stale isValid entries from the previous visit can't combine
// with a freshly-mounted section's immediate/optimistic isValid to make
// useCreateQrOnFirstValid see a false "form is valid" before every section
// has re-registered.
//
// Deliberately NOT called from resetContentFormSections() below: sections
// only re-write their entry into contentFormValidityAtom when their own
// isValid value changes (see useSyncFormSectionValidity), not on every
// render. If this ran after a batch of sections have already mounted and
// registered their real initial validity in the same commit (React fires
// child effects before the parent's), it would wipe their correct entries
// with nothing left to ever re-populate them — leaving the map incomplete,
// which makes the aggregate "every section valid" check in
// useCreateQrOnFirstValid vacuously true. Callers that need both resets
// must call this explicitly at a point that's provably before the target
// sections mount (e.g. QrTypeCard's click handler, before Step 2 navigates).
export const resetContentFormValidity = () => {
	getStore().set(contentFormValidityAtom, RESET)
}

export const resetContentFormSections = () => {
	// Common sections
	resetImagesField()
	resetWelcomeScreenForm()
	resetQrNameForm()
	resetAddressForm()
	resetSummaryAtom()
	resetContactInfoForm()
	resetBusinessInfoForm()
	resetFacilitiesForm()
	resetWebsiteUrlForm()
	// VCard form sections
	resetContentDesignForm()
	resetAboutForm()
	resetSocialLinksForm()
	// Images form sections
	resetImagesInfoForm()
	resetShareImageGalleryForm()
	resetPlainTextForm()
	// Wifi form sections
	resetWifiForm()
	// Facebook form sections
	resetFacebookForm()
	// app form sections
	resetAppForm()
	// Business page sections
	resetImageField()
	resetOpeningHoursForm()
	// Pdf form sections
	resetPdf()
	// Social Media sections
	resetSocialInformationForm()
	resetCustomSocialImagesField()
	// Menu form sections
	resetRestaurantInfoForm()
	resetMenuForm()
	// Video form sections
	resetVideoForm()
	resetVideoInformationForm()
	resetVideoList()
}
